'use client';

import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './style';

/**
 * @name NotificationBanner
 * @param {object} props - Strapi cms data
 * @returns {JSX.Element} - Renders Banner component
 */
const NotificationBanner = props => {
  const theme = useTheme();
  const style = useStyles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  /**
   * @name renderContent
   * @description - Injects raw html into the component
   * @param {string} content - Cms data from strapi
   * @returns {HTMLElement} - Returns html content
   */
  const renderContent = content => ({ __html: content });

  return (
    <Box sx={style.notification}>
      <Typography
        variant='body1'
        dangerouslySetInnerHTML={
          sm
            ? renderContent(props?.cmsData?.mobileMessage)
            : renderContent(props?.cmsData?.desktopMessage)
        }
      />
    </Box>
  );
};
NotificationBanner.displayName = 'NotificationBanner';
export default NotificationBanner;
